/* eslint-disable import/prefer-default-export */
import { isTrueReading } from '../../../../../../../utils/reading';
import { coreComputeBelowCriterions, getComparator, getLessNegativeComparator, getMoreNegativeComparator } from './core';

export const computeBelowCriterionsByThreshold = (
	surveyType,
	readings,
	readingsWithGaps,
	readingsWithGapsIndexMap,
	key,
	lessNegativeThreshold,
	comparatorKey,
	moreNegativeThreshold
) => {
	const getLessNegativeThreshold = () => lessNegativeThreshold;
	const getMoreNegativeThreshold = () => moreNegativeThreshold;
	const canCompare = reading => isTrueReading(reading) && reading[key] !== 0;
	const calcIsZeroReading = reading =>
		isTrueReading(reading) && reading[key] === 0;
	
	const comparator = getComparator(comparatorKey);
	return coreComputeBelowCriterions(
		surveyType,
		readings,
		readingsWithGaps,
		readingsWithGapsIndexMap,
		key,
		getLessNegativeThreshold,
		canCompare,
		calcIsZeroReading,
		comparator,
		getMoreNegativeThreshold,
		{
			lessNegativeComparator: getLessNegativeComparator(comparatorKey),
			moreNegativeComparator: getMoreNegativeComparator(comparatorKey),
		}	
	);
};
